import React from "react";
import { Helmet } from "react-helmet";

import { Link } from "@racepointenergy/gatsby-theme-sitespark/src/components/Html";

export default function NotFound404() {
  return (
    <div>
      <Helmet>
        <title>{"Not found - Savant Power"}</title>
      </Helmet>
      <h2>
        We couldn't find the page you were looking for. This is either because:
      </h2>
      <ul>
        <li>
          There is an error in the URL entered into your web browser. Please
          check the URL and try again.
        </li>
        <li>The page you are looking for has been moved or deleted.</li>
      </ul>
      <p>
        You can return to our homepage by clicking <Link to="/">here</Link>.
      </p>
    </div>
  );
}
